import { render } from "./StudentCreate.vue?vue&type=template&id=65efce86"
import script from "./StudentCreate.vue?vue&type=script&lang=js"
export * from "./StudentCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/eigyo65user/mystep/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__